import { EachPreviewedMergedFile } from './BookingPreviews';
import { ApiAttachmentForFS, FormattedMainFile } from './MainFiles';

class PreviewFileHelper {
  file:
    | FormattedMainFile
    | ApiAttachmentForFS
    | EachPreviewedMergedFile; // no locked
  constructor(
    file:
      | FormattedMainFile
      | ApiAttachmentForFS
      | EachPreviewedMergedFile,
  ) {
    this.file = file;
  }

  isPdf() {
    return this.file.mimeType === 'application/pdf';
  }

  isDownloadable() {
    return [
      'application/zip',
      'application/x-zip-compressed',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
    ].includes(this.file.mimeType);
  }
  isViewOrDownloadable() {
    return this.isPdf() || this.isDownloadable();
  }
  getFileTypeFromMimeType(): string {
    return this.file.mimeType?.replace(
      /(application|image|text|message)\//,
      '',
    );
  }

  hasGDriveLink() {
    return !!this.file.driveFileId;
  }
}

export default PreviewFileHelper;
